import { SxProps, Theme } from "@mui/material";
import { inarixColors } from "inarix-theme";

export const DONE_COLOR = "#4caf50";
export const PENDING_COLOR = "#bdbdbd";

export const cardSx: SxProps<Theme> = {
  width: "100%",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  px: 3,
  py: 1,
};

export const stepperSx: SxProps<Theme> = {
  width: "100%",
  p: 0,
  "& .MuiStep-root": { flex: 1, p: 0 },
};

export const stepLabelSx: SxProps<Theme> = {
  "& .MuiStepLabel-labelContainer": { mt: 0.25 },
  "& .MuiStepLabel-label": { mt: 0 },
};

export const checkIconSx: SxProps<Theme> = { fontSize: 14 };

export const titleColor = (isCompleted: boolean, isActive: boolean): string => {
  if (isCompleted) return DONE_COLOR;
  if (isActive) return inarixColors.main_inarix;
  return "text.disabled";
};

export const subtitleSx: SxProps<Theme> = { fontSize: "10px" };

export const stepIconRootBase = {
  width: 24,
  height: 24,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: "12px",
  color: "#fff",
};
